module.exports = __webpack_public_path__ + "img/home_bg_data@3x.cc2df698.png";